import AssetImage from "../../../assets/images/png/Insight.png";
import { analyticsTabsData } from "../../../utils/data";
import Overall from "../Overall/Overall";
import Equity from "../Equity/Equity";
import FixedIncome from "../FixedIncome/FixedIncome";
import loaderGIF from "../../../assets/images/gifs/loaderGIF.gif";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import downArrowBlack from "../../../assets/images/svg/downArrowBlack.svg";
import UserStore from "../../../store/UserStore";
import PerformanceStore from "../../../store/PerformanceStore";
import AnalyticsStore from "../../../store/AnalyticsStore";
import SelectNuvama from "../../SelectNuvama/SelectNuvama";
import { useRef } from "react";
import { getCookie, setCookie } from "../../../utils/cookie";
import PageHeading from "../../PageHeading/PageHeading";

const AnalyticsTabs = observer(({ snippetDuration, graphId, mainSection }) => {
  const overallRef = useRef({
    assetRef: null,
    amcExRef: null,
    overallDurationRef: null,
  });
  const equityRef = useRef({
    marketRef: null,
    sectorExRef: null,
    equityDurationRef: null,
  });

  const fixedRef = useRef({
    creditRef: null,
    issureRef: null,
    fixedDurationRef: null,
  });

  const [modalVisibility, setModalVisibility] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isScrolledIssuer, setIsScrolledIssuer] = useState(false);

  const userId = AnalyticsStore?.overall?.userId || getCookie("userid");

  const handleWealth = () => {
    AnalyticsStore.setOverall({
      ...AnalyticsStore.overall,
      userId: UserStore.userData.user_id,
      isPrimary: UserStore.userData.isprimary,
      selectedItemBestAndWorst: {
        id: "0",
        name: "Across Categories",
      },
    });

    AnalyticsStore.setEquity({
      ...AnalyticsStore.equity,
      selectedItemBestAndWorst: {
        id: "",
        name: "Across Categories",
      },
      marketCapSelectedOption: {
        id: 1,
        value: "Direct Equity + MF Equity",
        apiKey: "all",
      },
      sectoralAllocationSelectedOption: {
        id: 1,
        value: "Direct Equity + MF Equity",
        apiKey: "all",
      },
      stockConcentrationSelectedOption: {
        id: 1,
        value: "Direct Equity + MF Equity",
        apiKey: "all",
      },
    });

    AnalyticsStore.setFixedIncome({
      ...AnalyticsStore.equity,
      selectedItemBestAndWorst: {
        id: "",
        name: "Across Categories",
      },
      creditScoreSelectedOption: {
        id: 1,
        value: "Bonds + MF Debt",
        apiKey: "all",
      },
      issuerExposureSelectedOption: {
        id: 1,
        value: "Bonds + MF Debt",
        apiKey: "all",
      },
    });
  };

  useEffect(() => {
    handleWealth();
    let familyId = UserStore?.userData?.family_id;
    let userId = UserStore?.userData?.user_id;
    if (!familyId) familyId = getCookie("familyId");
    if (!userId) userId = getCookie("userid");
  }, []);

  const tabsDivRef = useRef(null);
  const scrollToTop = () => {
    if (tabsDivRef.current) tabsDivRef.current?.scrollTo(0, 0);
  };

  const handleTab = (tabsData, i) => {
    UserStore.setSelectedAnalyticsTab(tabsData);
    setCookie("selectedTabA", i);
    scrollToTop();
  };

  useEffect(() => {
    scrollToTop();
  }, [userId]);

  // Easing function for smooth animation
  const easeInOutCubic = (t) => {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  };

  const smoothScroll = (start, end, duration, updateScrollPosition) => {
    let startTime;

    const animationStep = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const timeElapsed = timestamp - startTime;
      const progress = timeElapsed / duration;

      const easedProgress = easeInOutCubic(progress);

      // Calculate the new scroll position
      const newScrollPosition = start + (end - start) * easedProgress;

      updateScrollPosition(newScrollPosition);

      if (timeElapsed < duration) {
        requestAnimationFrame(animationStep);
      }
    };

    requestAnimationFrame(animationStep);
  };

  useEffect(() => {
    const getRef = () => {
      switch (mainSection) {
        case "Overall":
          return graphId === mainSection
            ? overallRef?.current?.overallDurationRef
            : graphId === "AssetAllocation"
            ? overallRef.current?.assetRef
            : overallRef.current?.amcExRef;
        case "Equity":
          return graphId === mainSection
            ? equityRef?.current?.equityDurationRef
            : graphId === "MarketCapAllocation"
            ? equityRef.current?.marketRef
            : equityRef.current?.sectorExRef;
        case "Fixed Income":
          return graphId === mainSection
            ? fixedRef?.current?.fixedDurationRef
            : graphId === "CreditRatingExposure"
            ? fixedRef.current?.creditRef
            : fixedRef.current?.issureRef;
        default:
          return null;
      }
    };

    //  Ensure the container and its children are loaded
    const container = tabsDivRef.current;
    const targetChild = getRef();

    //document.getElementById(graphId);
    // document.getElementById(snippetDuration); // The 4th child (index 3)

    const graphIdSpace = {
      IssuerExposure: -100,
      CreditRatingExposure: -105,
      AMC_Exposure: 50,
    };

    const isScrollNeeded = () => {
      if (
        graphId === "IssuerExposure" &&
        isScrolled &&
        AnalyticsStore.fixedIncome.durationAnalysis?.length > 2
      )
        return true;
      return false;
    };

    const minusValue = graphIdSpace[graphId || 0] || 0;

    if (graphId && container && targetChild && !isScrolled) {
      const startScroll = container.scrollTop; // Current scroll position
      const targetScroll = targetChild.offsetTop; // Position of the 4th child
      // Start smooth scrolling to the target position
      setIsScrolled(true);

      smoothScroll(
        startScroll,
        targetScroll - 200 - minusValue,
        1500,
        (newPosition) => {
          container.scrollTop = newPosition;
        }
      );
    } else if (
      container &&
      targetChild &&
      !isScrolledIssuer &&
      isScrollNeeded()
    ) {
      const startScroll = container.scrollTop; // Current scroll position
      const targetScroll = targetChild.offsetTop; // Position of the 4th child
      setIsScrolledIssuer(true);
      // Start smooth scrolling to the target position

      smoothScroll(startScroll, targetScroll - 200, 180, (newPosition) => {
        container.scrollTop = newPosition;
      });
    }
  }, [
    AnalyticsStore.overall,
    AnalyticsStore?.equity,
    AnalyticsStore.fixedIncome,
  ]);

  return (
    UserStore.isHydrated && (
      <div
        ref={tabsDivRef}
        className="analytics-scrollable-div"
        style={{ height: window.innerHeight - 108 }}
      >
        <div className="asset_heading_section">
          <img src={AssetImage} alt="" className="insight-icon" />
          <PageHeading
            headingClass="analytics-heading"
            headingText="Insights & Analytics"
          />
        </div>
        <div className="tab_container">
          <div
            style={{
              position: modalVisibility ? "inherit" : "sticky",
              top: -1,
              backgroundColor: "#fff",
              zIndex: 2,
            }}
          >
            <div className="tabs_part analytics_tabs">
              <div className="tabs port_tabs">
                <ul>
                  {analyticsTabsData.map((tabsData, i) => (
                    <li
                      className={`analytics-tab
                    ${
                      (UserStore.isHydrated &&
                        UserStore.selectedAnalyticsTab === tabsData) ||
                      Number(getCookie("selectedTabA")) === i
                        ? "is-active"
                        : "analytics-tabs-button-animation"
                    }`}
                      key={i}
                      onClick={() => {
                        handleTab(tabsData, i);
                      }}
                    >
                      {/* <a style={{ fontSize: 14, padding: "15px 28px" }}>
                        {tabsData}
                      </a> */}
                      <button style={{ fontSize: 14, padding: "15px 28px" }}>
                        {tabsData}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <SelectNuvama
                type={"onlybtn"}
                handleWealth={() => {
                  handleWealth();
                  UserStore.getReportsPersistData();
                }}
                memberDropdownClass="analytics-members-dropdown"
                memberDropdownTextClass="analytics-members-dropdown-text"
                downArrowIcon={downArrowBlack}
                onModalVisibilityChange={(state) => setModalVisibility(state)}
              />
            </div>
            <div
              style={{ backgroundColor: "#fff", height: 20, width: "100%" }}
            />
          </div>
          {PerformanceStore.mainTabLoader ? (
            <div className="report_table_loader">
              <div className="report_loader_wrapper add_margin">
                <img className="loading_gif" src={loaderGIF} alt="loading..." />
              </div>
            </div>
          ) : (
            <div>
              {UserStore.selectedAnalyticsTab === "Overall" && (
                <Overall snippetDuration={snippetDuration} ref={overallRef} />
              )}
              {UserStore.selectedAnalyticsTab === "Equity" && (
                <Equity snippetDuration={snippetDuration} ref={equityRef} />
              )}
              {UserStore.selectedAnalyticsTab === "Fixed Income" && (
                <FixedIncome snippetDuration={snippetDuration} ref={fixedRef} />
              )}
            </div>
          )}
        </div>
      </div>
    )
  );
});

export default AnalyticsTabs;
